// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"de357ee3","222":"3505e659","280":"2c14e764","320":"94272361","526":"de357ee3","567":"fe83684d","836":"c95cc300","860":"51257e3e"}[chunkId] + ".chunk.css";
};